module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fas fa-ellipsis-h fs-largest ml-2 dark pointer",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleList.apply(null, arguments)
      }
    }
  }), _vm._v(" "), (_vm.listOpen) ? _c('ul', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.closeList),
      expression: "closeList"
    }],
    class: [
      'actions position-absolute border-medium shadowed',
      _vm.isLighter ? 'bg-lighter' : 'bg-lightest'
    ],
    on: {
      "click": _vm.closeList
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ({
          content: item.toolTip,
          delay: {
            show: 1000,
            hide: 1000
          },
          classes: ['dark']
        }),
        expression: "{content: item.toolTip, delay: {show: 1000, hide: 1000}, classes: ['dark']}",
        modifiers: {
          "left": true
        }
      }],
      staticClass: "fs-small",
      on: {
        "click": function($event) {
          return _vm.selectItem(item)
        }
      }
    }, [_c('div', {
      class: _vm.divClass
    }, [_vm._v("\n                " + _vm._s(item.label) + "\n            ")])])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7194a311"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/threeDots.vue
// module id = 1209
// module chunks = 0